import React, { Fragment, useState, useEffect } from "react";

import { IonActionSheet, IonLoading } from "@ionic/react";

import { close, imagesOutline, cameraOutline } from "ionicons/icons";

import { useTransfer } from "../../hooks/useFileTransfer";

import { UserPhoto } from "../../components/Ui/UserPhoto";

import { usePhotoGallery } from "../../hooks/useCamera";

export const AccountAvatar: React.FC<{}> = () => {
  const [showActionSheet, setShowActionSheet] = useState(false);
  const { upload, loading } = useTransfer();
  const { takePhoto, photos } = usePhotoGallery();

  useEffect(() => {
    if (photos.length) {
      upload(photos[0]);
    }
  }, [photos]);

  return (
    <Fragment>
      <UserPhoto onClick={() => setShowActionSheet(true)} />
      <IonLoading isOpen={loading} message="Realizando o enviando foto" />
      <IonActionSheet
        isOpen={showActionSheet}
        onDidDismiss={() => setShowActionSheet(false)}
        buttons={[
          {
            text: "Tirar Foto",
            role: "camera_take",
            icon: cameraOutline,
            handler: () => {
              takePhoto();
              // console.log("Delete clicked");
            },
          },
          {
            text: "Galeria",
            role: "gallery",
            icon: imagesOutline,
            handler: () => {
              console.log("Delete clicked");
            },
          },
          {
            text: "Cancelar",
            icon: close,
            role: "cancel",
            handler: () => {
              console.log("Cancel clicked");
            },
          },
        ]}
      ></IonActionSheet>
    </Fragment>
  );
};
